<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '800px'}"
  [contentStyle]="{'max-height': '90vh', 'overflow-y': 'auto'}"
  styleClass="p-fluid conferma-finanziamento-dialog"
  [showHeader]="false"
  (onHide)="hide()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-money-bill header-icon"></i>
        <h3>Conferma Finanziamento dell'intervento</h3>
         <div class="code-badge" style="background-color: #f5f5f5; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem;">
          <span class="code-value" style="font-weight: bold; color: #3a6e75;">{{ intervento?.scheda?.codice }}</span>
        </div>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hide()">
      </button>
    </div>

    <div class="dialog-content">
      <form [formGroup]="form" class="p-fluid">
        <div style="display: flex; gap: 2rem; align-items: center; justify-content: center; padding: 1rem;">
          <div style="width: 320px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
            <label for="importoContributo" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo RIMODULATO dall'ente esecutore</label>
            <p-inputNumber
              id="importoContributo"
              formControlName="importoContributo"
              mode="currency"
              currency="EUR"
              locale="it-IT"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              styleClass="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>
          <div style="display: flex; align-items: center; color: #6c757d;">
            <i class="pi pi-arrow-right" style="font-size: 2rem;"></i>
          </div>
          <div style="width: 320px; background: #f8f9fa; padding: 1.5rem; border-radius: 8px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
            <label for="importoFinanziato" style="display: block; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">Importo FINANZIATO</label>
            <p-inputNumber
              id="importoFinanziato"
              formControlName="importoFinanziato"
              mode="currency"
              currency="EUR"
              locale="it-IT"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              styleClass="w-full"
              [style]="{'width': '100%'}">
            </p-inputNumber>
          </div>
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hide()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-primary"
        (click)="conferma()">
      </button>
    </div>
  </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
